/** Types de bannière (slider, promo, etc.) */
export const BANNER_TYPE = Object.freeze({
  BANNIERE: 'BANNIERE',
  PROMO: 'PROMO',
});

/** Sections de bannière (emplacements) */
export const BANNER_SECTION = Object.freeze({
  SECTION_1: 'SECTION_1',
  SECTION_2: 'SECTION_2',
  SECTION_3: 'SECTION_3',
});
